module.exports = __webpack_public_path__ + "img/pin_take_away_purple.86255ea0.svg";